import { initializeApp } from 'firebase/app'
import { deleteToken, getMessaging, getToken, onMessage } from 'firebase/messaging'

// 正式key
const firebaseConfig = {
  apiKey: 'AIzaSyBxqqhVW1oLbn3KSy3pcSmdVnGj-2mUKx4',
  authDomain: 'dfans-fcm.firebaseapp.com',
  projectId: 'dfans-fcm',
  storageBucket: 'dfans-fcm.firebasestorage.app',
  messagingSenderId: '809765510850',
  appId: '1:809765510850:web:b9b23761a830b34022255b',
}

// 测试 key
// const firebaseConfig = {
//   apiKey: 'AIzaSyBxm0VbWNiAhJjFedzBIy5Ja7Xgsv3gj2c',
//   authDomain: 'default-test-440315.firebaseapp.com',
//   projectId: 'default-test-440315',
//   storageBucket: 'default-test-440315.firebasestorage.app',
//   messagingSenderId: '657997614183',
//   appId: '1:657997614183:web:b963e8defc02bf7ec618c2',
//   measurementId: 'G-2F0HC4H9LS',
// }

const app = initializeApp(firebaseConfig)
let messaging: any = null
if ('PushManager' in window) {
  messaging = getMessaging(app)
}

export { messaging, onMessage, getToken, deleteToken }
